let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h2l6C")).then(() => parcelRequire('iPlLr'));